import ObservationCardGridView from "@/components/observations/ObservationCardGridView";
import { useAreaName } from "@/hooks/useAreaName";
import type { LayoutContext } from "@/lib/models";
import { ObservationService, type Observation } from "@/services/ObservationService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const AreaCourseObservationListPage: React.FC = () => {
  const [observations, setActionsList] = useState<Observation[]>([]);
  const params = useParams();
  const { areaName } = useAreaName(params.areaId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Feature: ${areaName} Course Observations`);
    }, [areaName, setPageName]);

  useEffect(() => {
    ObservationService
      .getByAreaIdCourse(params.areaId!)
      .then(setActionsList);
  }, [params.siteId]);

  return (
    <div className="container mx-auto p-4">
      <ObservationCardGridView observations={observations} pageTitle={`Area: ${areaName} Course Observations`} />
    </div>
  );
};

export default AreaCourseObservationListPage;
